(() => {
  const root = document.querySelector("#jt-quiz");
  if (!root) return;

  const dataEl = root.querySelector("#jt-quiz-data");
  const screen = root.querySelector("#jt-quiz-screen");
  const progressText = root.querySelector("#jt-quiz-progressText");
  if (!dataEl || !screen) return;

  const pageWrap = root.closest(".jt-quiz-page") || document;
  const pageTitle = pageWrap.querySelector(".jt-quiz__title");
  const pageSubtitle = pageWrap.querySelector(".jt-quiz__subtitle");

  let DATA = null;
  try {
    DATA = JSON.parse(dataEl.textContent || "{}");
  } catch (e) {
    console.error("[JT QUIZ] JSON parse error:", e);
    return;
  }

  const RAW_QUESTIONS = Array.isArray(DATA.questions) ? DATA.questions : [];
  const PERSONAS = DATA.personas || {};
  const PERSONA_KEYS = Object.keys(PERSONAS);
  const CFG = DATA.config || {};
  const AUTO_NEXT = CFG.autoNext === true;
  const ASK_LEAD = CFG.askLead === true;
  const REQUIRE_LEAD = CFG.requireLead === true;
  const c = window.crypto || window.msCrypto;
  const sessionId =
    c && typeof c.randomUUID === "function"
      ? c.randomUUID()
      : String(Date.now()) + "-" + Math.random().toString(16).slice(2);

  function hashSeed(str) {
    let h = 2166136261;
    const s = String(str || "");
    for (let i = 0; i < s.length; i++) {
      h ^= s.charCodeAt(i);
      h = Math.imul(h, 16777619);
    }
    return h >>> 0;
  }

  function mulberry32(seed) {
    let a = seed >>> 0;
    return function () {
      a |= 0;
      a = (a + 0x6d2b79f5) | 0;
      let t = Math.imul(a ^ (a >>> 15), 1 | a);
      t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
  }

  function buildShuffledQuestions(src) {
    const MAX_MODELS = 7;
    const seed = hashSeed("jtq:models");
    const rnd = mulberry32(seed);
    const baseOrder = src.map((_, i) => i);
    const movableIdx = baseOrder.filter(
      (i) => src[i] && src[i].type !== "ranking" && src[i].type !== "powerup",
    );
    const models = [];
    for (let m = 0; m < MAX_MODELS; m++) {
      const order = baseOrder.slice();
      const shuffled = movableIdx.slice();
      for (let i = shuffled.length - 1; i > 0; i--) {
        const j = Math.floor(rnd() * (i + 1));
        [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
      }

      let k = 0;
      for (let i = 0; i < order.length; i++) {
        if (
          src[order[i]] &&
          src[order[i]].type !== "ranking" &&
          src[order[i]].type !== "powerup"
        ) {
          order[i] = shuffled[k++];
        }
      }

      models.push(order);
    }

    const pickRnd = mulberry32(hashSeed("jtq:pick:" + sessionId));
    const pickedModel = models[Math.floor(pickRnd() * models.length)];
    return pickedModel.map((idx) => src[idx]);
  }

  const QUESTIONS = buildShuffledQuestions(RAW_QUESTIONS);

  function setHeaderVisibility(isResult) {
    if (pageTitle) pageTitle.style.display = isResult ? "none" : "";
    if (pageSubtitle) pageSubtitle.style.display = isResult ? "none" : "";
    if (progressText) progressText.style.display = isResult ? "none" : "";
  }

  const POWER_ICONS = {
    shadow: `
      <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12.9163 21.6666C12.8997 21.0833 13.1663 20.5166 13.6163 20.1333C14.8663 20.3999 16.033 20.9166 17.083 21.6666C17.083 22.7999 16.1497 23.7333 14.9997 23.7333C13.8497 23.7333 12.933 22.8166 12.9163 21.6666ZM22.9163 21.6666C23.9663 20.9333 25.133 20.4166 26.383 20.1499C26.833 20.5333 27.0997 21.0999 27.083 21.6666C27.083 22.8333 26.1497 23.7666 24.9997 23.7666C23.8497 23.7666 22.9163 22.8333 22.9163 21.6666ZM19.9997 14.9999C15.383 14.9333 10.833 16.0833 6.78301 18.3333L6.66634 19.9999C6.66634 22.0499 7.14967 24.0666 8.06634 25.8999C15.9764 24.6964 24.023 24.6964 31.933 25.8999C32.8497 24.0666 33.333 22.0499 33.333 19.9999L33.2163 18.3333C29.1782 16.0851 24.621 14.9357 19.9997 14.9999ZM19.9997 3.33325C22.1884 3.33325 24.3556 3.76435 26.3777 4.60193C28.3998 5.4395 30.2371 6.66716 31.7848 8.21481C33.3324 9.76245 34.5601 11.5998 35.3977 13.6219C36.2352 15.644 36.6663 17.8112 36.6663 19.9999C36.6663 24.4202 34.9104 28.6594 31.7848 31.785C28.6592 34.9106 24.4199 36.6666 19.9997 36.6666C17.811 36.6666 15.6437 36.2355 13.6216 35.3979C11.5995 34.5603 9.7622 33.3327 8.21456 31.785C5.08896 28.6594 3.33301 24.4202 3.33301 19.9999C3.33301 15.5796 5.08896 11.3404 8.21456 8.21481C11.3402 5.0892 15.5794 3.33325 19.9997 3.33325Z" fill="#356289"/>
      </svg>
    `,
    aesthetic: `
      <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14.4333 21.7834C11.5333 21.7834 9.16667 19.4334 9.16667 16.5501C9.16667 15.3667 9.6 14.2334 10.3167 13.3334C9.61667 12.4334 9.16667 11.3001 9.16667 10.1167C9.16667 7.23341 11.55 4.88341 14.4333 4.88341L15.15 4.93341C15.5434 3.96934 16.2145 3.14401 17.0781 2.56233C17.9417 1.98066 18.9588 1.66892 20 1.66675C22.1833 1.66675 24.0667 3.01675 24.85 4.93341L25.5667 4.88341C28.45 4.88341 30.8333 7.23341 30.8333 10.1167C30.8333 11.3001 30.4 12.4334 29.6833 13.3334C30.3833 14.2334 30.8333 15.3667 30.8333 16.5501C30.8333 19.4334 28.45 21.7834 25.5667 21.7834L24.85 21.7334C24.4566 22.6975 23.7855 23.5228 22.9219 24.1045C22.0583 24.6862 21.0412 24.9979 20 25.0001C18.9588 24.9979 17.9417 24.6862 17.0781 24.1045C16.2145 23.5228 15.5434 22.6975 15.15 21.7334L14.4333 21.7834ZM20 21.6667C21.0333 21.6667 21.8667 20.8334 21.9 19.8334L21.7167 18.0167C21.1833 18.2167 20.6 18.3334 20 18.3334C19.4 18.3334 18.8333 18.2167 18.3333 18.0167L18.1 19.8334C18.1333 20.8334 18.9667 21.6667 20 21.6667ZM25.5667 18.4501C26.6167 18.4501 27.5 17.6001 27.5 16.5334C27.5 15.8334 27.05 15.1334 26.3833 14.8167L24.9167 14.1167C24.7167 15.3501 24.0667 16.4167 23.15 17.1667L24.5 18.1167C24.8 18.3334 25.1667 18.4501 25.5667 18.4501ZM24.4833 8.55008L23.1167 9.48341C24.05 10.2334 24.7 11.3001 24.9 12.5001L26.3667 11.8334C27.05 11.5001 27.5 10.8334 27.5 10.1167C27.5 9.06675 26.6167 8.21675 25.5667 8.21675C25.1833 8.21675 24.8167 8.33341 24.4833 8.55008ZM20 5.00008C18.9667 5.00008 18.1333 5.83341 18.1 6.83341L18.3333 8.65008C18.8333 8.45008 19.4 8.33341 20 8.33341C20.6 8.33341 21.1833 8.45008 21.7167 8.65008L21.9 6.83341C21.8667 5.83341 21.0333 5.00008 20 5.00008ZM14.4333 8.21675C13.3833 8.21675 12.5 9.06675 12.5 10.1167C12.5 10.8334 12.95 11.5001 13.6167 11.8334L15.0833 12.5001C15.2833 11.3001 15.9333 10.2334 16.85 9.48341L15.5 8.55008C15.2 8.33341 14.8333 8.21675 14.4333 8.21675ZM13.6167 14.8334C12.95 15.1667 12.5 15.8334 12.5 16.5334C12.5 17.5834 13.3833 18.4334 14.4333 18.4334C14.8167 18.4334 15.1833 18.3334 15.5167 18.1001L16.8667 17.1834C15.9333 16.4334 15.2833 15.3667 15.0833 14.1667L13.6167 14.8334ZM20 36.6667C16.0218 36.6667 12.2064 35.0864 9.3934 32.2733C6.58035 29.4603 5 25.645 5 21.6667C8.97825 21.6667 12.7936 23.2471 15.6066 26.0601C18.4196 28.8732 20 32.6885 20 36.6667C20 32.6885 21.5804 28.8732 24.3934 26.0601C27.2064 23.2471 31.0218 21.6667 35 21.6667C35 25.645 33.4196 29.4603 30.6066 32.2733C27.7936 35.0864 23.9782 36.6667 20 36.6667ZM24.0667 32.6001C25.635 32.012 27.0593 31.0949 28.2437 29.9105C29.4281 28.7261 30.3452 27.3018 30.9333 25.7334C27.7667 26.9001 25.25 29.4334 24.0667 32.6001ZM9.06667 25.7334C9.65478 27.3018 10.5719 28.7261 11.7563 29.9105C12.9407 31.0949 14.365 32.012 15.9333 32.6001C14.7667 29.4334 12.2333 26.9167 9.06667 25.7334Z" fill="#356289"/>
      </svg>
    `,
    fearless: `
      <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.667 38.3334H28.3337V28.3334H25.0003V35.0001H15.0003V28.3334H11.667V38.3334ZM5.00033 38.3334H8.33366V31.6667H5.00033V38.3334ZM8.33366 28.3334H11.667V25.0001H8.33366V28.3334ZM1.66699 31.6667H5.00033V25.0001H8.33366V8.33341H5.00033V21.6667H1.66699V31.6667ZM18.3337 31.6667H21.667V21.6667H18.3337V31.6667ZM31.667 38.3334H35.0003V31.6667H31.667V38.3334ZM11.667 21.6667H15.0003V18.3334H18.3337V11.6667H15.0003V15.0001H11.667V21.6667ZM8.33366 8.33341H11.667V5.00008H8.33366V8.33341ZM28.3337 28.3334H31.667V25.0001H28.3337V28.3334ZM25.0003 21.6667H28.3337V15.0001H25.0003V11.6667H21.667V18.3334H25.0003V21.6667ZM35.0003 31.6667H38.3337V21.6667H35.0003V8.33341H31.667V25.0001H35.0003V31.6667ZM11.667 5.00008H28.3337V1.66675H11.667V5.00008ZM28.3337 8.33341H31.667V5.00008H28.3337V8.33341Z" fill="#356289"/>
        <line x1="2" y1="38.2322" x2="37.2457" y2="2.98649" stroke="#356289" stroke-width="2.5" stroke-linecap="square"/>
      </svg>
    `,
    endurance: `
      <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M20.6817 21.6949C21.4414 19.9339 22.7853 18.4889 24.4866 17.6036C26.1879 16.7182 28.1425 16.4468 30.0206 16.8352C31.8988 17.2235 33.5855 18.2477 34.7963 19.7351C36.007 21.2225 36.6676 23.082 36.6667 24.9999C36.6667 31.4433 30 36.6666 21.6667 36.6666C14.8717 36.6666 8.07836 35.2999 4.38169 32.5633C3.67169 32.0366 3.33002 31.1766 3.34836 30.2933C3.53002 21.2049 4.37836 3.33325 16.6667 3.33325C17.9928 3.33325 19.2645 3.86004 20.2022 4.79772C21.1399 5.7354 21.6667 7.00717 21.6667 8.33325C21.6667 9.21731 21.3155 10.0652 20.6904 10.6903C20.0653 11.3154 19.2174 11.6666 18.3334 11.6666C16.4917 11.6666 15.6 10.9266 15 9.99992" stroke="#356289" stroke-width="3.33333" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M25.0004 23.3333C23.9945 22.5785 22.8309 22.0611 21.5966 21.8199C20.3624 21.5788 19.0896 21.6201 17.8736 21.9408C16.6576 22.2614 15.53 22.8532 14.5752 23.6716C13.6204 24.49 12.8632 25.514 12.3604 26.6666" stroke="#356289" stroke-width="3.33333" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M16.6063 11.375C13.3647 13.295 15.833 21.6667 13.333 25" stroke="#356289" stroke-width="3.33333" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    `,
    control: `
      <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M37.1338 24.1162L33.3838 20.3662C33.1493 20.1319 32.8315 20.0003 32.5 20.0003C32.1685 20.0003 31.8507 20.1319 31.6162 20.3662L20 31.9825V37.5H25.5175L37.1338 25.8838C37.3681 25.6493 37.4997 25.3315 37.4997 25C37.4997 24.6685 37.3681 24.3507 37.1338 24.1162ZM24.4825 35H22.5V33.0175L28.75 26.7675L30.7325 28.75L24.4825 35ZM32.5 26.9825L30.5175 25L32.5 23.0175L34.4825 25L32.5 26.9825ZM10 20H22.5V22.5H10V20ZM10 12.5H25V15H10V12.5Z" fill="#356289"/>
        <path d="M32.5 5C32.5 4.33696 32.2366 3.70107 31.7678 3.23223C31.2989 2.76339 30.6631 2.5 30 2.5H5.00001C4.33697 2.5 3.70108 2.76339 3.23224 3.23223C2.7634 3.70107 2.50001 4.33696 2.50001 5V21.25C2.49709 23.743 3.17322 26.1896 4.4558 28.3274C5.73839 30.4651 7.579 32.2131 9.78001 33.3838L16.25 36.8337V34L10.9575 31.1775C9.15705 30.2192 7.65136 28.7889 6.60186 27.04C5.55236 25.2912 4.99862 23.2896 5.00001 21.25V5H30V16.25H32.5V5Z" fill="#356289"/>
      </svg>
    `,
  };

  const POWER_Q7_ICON_MAP = {
    reset: `
      <svg width="33" height="35" viewBox="0 0 33 35" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M23.925 6.51163C24.8002 6.51163 25.6396 6.16861 26.2585 5.55802C26.8773 4.94744 27.225 4.11931 27.225 3.25581C27.225 2.39232 26.8773 1.56419 26.2585 0.953606C25.6396 0.343022 24.8002 0 23.925 0C23.0498 0 22.2104 0.343022 21.5915 0.953606C20.9727 1.56419 20.625 2.39232 20.625 3.25581C20.625 4.11931 20.9727 4.94744 21.5915 5.55802C22.2104 6.16861 23.0498 6.51163 23.925 6.51163ZM17.985 29.1395L19.635 21.9767L23.1 25.2326V35H26.4V22.7907L22.935 19.5349L23.925 14.6512C25.0556 15.9293 26.4504 16.9538 28.0157 17.6558C29.5811 18.3577 31.2806 18.7209 33 18.7209V15.4651C30.096 15.514 27.39 14.0163 25.905 11.5581L24.255 8.95349C23.661 7.97674 22.605 7.32558 21.45 7.32558C20.955 7.32558 20.625 7.48837 20.13 7.48837L11.55 11.0698V18.7209H14.85V13.186L17.82 12.0465L15.18 25.2326L7.095 23.6047L6.435 26.8605L17.985 29.1395ZM3.3 12.2093C2.86239 12.2093 2.44271 12.0378 2.13327 11.7325C1.82384 11.4272 1.65 11.0131 1.65 10.5814C1.65 10.1496 1.82384 9.73558 2.13327 9.43029C2.44271 9.125 2.86239 8.95349 3.3 8.95349H8.25V12.2093H3.3ZM4.95 5.69767C4.51239 5.69767 4.09271 5.52616 3.78327 5.22087C3.47384 4.91558 3.3 4.50152 3.3 4.06977C3.3 3.63802 3.47384 3.22395 3.78327 2.91866C4.09271 2.61337 4.51239 2.44186 4.95 2.44186H13.2V5.69767H4.95ZM1.65 18.7209C1.21239 18.7209 0.792709 18.5494 0.483274 18.2441C0.173839 17.9388 0 17.5248 0 17.093C0 16.6613 0.173839 16.2472 0.483274 15.9419C0.792709 15.6366 1.21239 15.4651 1.65 15.4651H8.25V18.7209H1.65Z" fill="#356289"/>
      </svg>
    `,
    stamina: `
      <svg width="37" height="37" viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M23.3197 21.6668C22.3138 20.912 21.1502 20.3946 19.916 20.1534C18.6817 19.9123 17.4089 19.9536 16.1929 20.2743C14.9769 20.5949 13.8493 21.1867 12.8945 22.0051C11.9397 22.8235 11.1825 23.8475 10.6797 25.0001" stroke="#356289" stroke-width="3.33333" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M14.9257 9.7085C11.684 11.6285 14.1523 20.0002 11.6523 23.3335" stroke="#356289" stroke-width="3.33333" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M19.001 20.0284C19.7607 18.2674 21.1046 16.8224 22.8059 15.937C24.5072 15.0517 26.4618 14.7803 28.34 15.1687C30.2181 15.557 31.9049 16.5812 33.1156 18.0686C34.3263 19.556 34.987 21.4155 34.986 23.3334C34.986 29.7767 28.3194 35.0001 19.986 35.0001C13.191 35.0001 6.39769 33.6334 2.70103 30.8967C1.99103 30.3701 1.64936 29.5101 1.66769 28.6267C1.84936 19.5384 2.69769 1.66675 14.986 1.66675C16.3121 1.66675 17.5839 2.19353 18.5216 3.13121C19.4592 4.0689 19.986 5.34067 19.986 6.66675C19.986 7.5508 19.6348 8.39865 19.0097 9.02377C18.3846 9.64889 17.5367 10.0001 16.6527 10.0001C14.811 10.0001 13.9194 9.26008 13.3194 8.33341" stroke="#356289" stroke-width="3.33333" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    `,
    emotional: `
      <svg width="34" height="22" viewBox="0 0 34 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.5356 6.66612H4.9995C4.11553 6.66612 3.26777 7.01727 2.64271 7.64233C2.01765 8.26739 1.6665 9.11515 1.6665 9.99912V16.6651C1.6665 17.5491 2.01765 18.3968 2.64271 19.0219C3.26777 19.647 4.11553 19.9981 4.9995 19.9981H26.664C27.548 19.9981 28.3957 19.647 29.0208 19.0219C29.6458 18.3968 29.997 17.5491 29.997 16.6651V9.99912C29.997 9.11515 29.6458 8.26739 29.0208 7.64233C28.3957 7.01727 27.548 6.66612 26.664 6.66612H21.1229L21.2729 6.36615C21.5012 5.91619 21.5462 5.43957 21.4529 4.99962H26.664C27.99 4.99962 29.2616 5.52635 30.1992 6.46394C31.1368 7.40152 31.6635 8.67317 31.6635 9.99912C32.1055 9.99912 32.5294 10.1747 32.8419 10.4872C33.1544 10.7998 33.33 11.2236 33.33 11.6656V14.9986C33.33 15.4406 33.1544 15.8645 32.8419 16.177C32.5294 16.4895 32.1055 16.6651 31.6635 16.6651C31.6635 17.9911 31.1368 19.2627 30.1992 20.2003C29.2616 21.1379 27.99 21.6646 26.664 21.6646H4.9995C3.67355 21.6646 2.40191 21.1379 1.46432 20.2003C0.526732 19.2627 0 17.9911 0 16.6651L0 9.99912C0 8.67317 0.526732 7.40152 1.46432 6.46394C2.40191 5.52635 3.67355 4.99962 4.9995 4.99962H11.3789L10.5356 6.66612ZM10.2106 8.33262C10.4056 9.24419 11.2022 9.99245 12.2554 9.99245H13.332V12.7755C13.332 15.1036 16.4717 15.8635 17.5282 13.7754L20.278 8.33262H21.6645C22.1065 8.33262 22.5304 8.50819 22.8429 8.82072C23.1554 9.13325 23.331 9.55713 23.331 9.99912V16.6651C23.331 17.1071 23.1554 17.531 22.8429 17.8435C22.5304 18.156 22.1065 18.3316 21.6645 18.3316H4.9995C4.55752 18.3316 4.13364 18.156 3.82111 17.8435C3.50858 17.531 3.333 17.1071 3.333 16.6651V9.99912C3.333 9.55713 3.50858 9.13325 3.82111 8.82072C4.13364 8.50819 4.55752 8.33262 4.9995 8.33262H10.2106ZM15.6201 0.303418C15.8817 -0.213197 16.6617 -0.0298819 16.6617 0.55006V5.00128H19.4064C19.723 5.00128 19.928 5.33458 19.7847 5.61789L16.0384 13.0255C15.7768 13.5421 14.9985 13.3554 14.9985 12.7772V8.32762H12.2538C11.9371 8.32762 11.7322 7.99432 11.8738 7.71101L15.6201 0.303418Z" fill="#356289"/>
      </svg>
    `,
    lock: `
      <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15 0V3.45C12.0666 3.82199 9.34013 5.15849 7.24931 7.24931C5.15849 9.34013 3.82199 12.0666 3.45 15H0V18.3333H3.45C3.82199 21.2667 5.15849 23.9932 7.24931 26.084C9.34013 28.1748 12.0666 29.5113 15 29.8833V33.3333H18.3333V29.8833C21.2667 29.5113 23.9932 28.1748 26.084 26.084C28.1748 23.9932 29.5113 21.2667 29.8833 18.3333H33.3333V15H29.8833C29.5113 12.0666 28.1748 9.34013 26.084 7.24931C23.9932 5.15849 21.2667 3.82199 18.3333 3.45V0M15 6.8V10H18.3333V6.81667C22.5 7.5 25.8333 10.8333 26.5333 15H23.3333V18.3333H26.5167C25.8333 22.5 22.5 25.8333 18.3333 26.5333V23.3333H15V26.5167C10.8333 25.8333 7.5 22.5 6.8 18.3333H10V15H6.81667C7.5 10.8333 10.8333 7.5 15 6.8ZM16.6667 15C16.2246 15 15.8007 15.1756 15.4882 15.4882C15.1756 15.8007 15 16.2246 15 16.6667C15 17.1087 15.1756 17.5326 15.4882 17.8452C15.8007 18.1577 16.2246 18.3333 16.6667 18.3333C17.1087 18.3333 17.5326 18.1577 17.8452 17.8452C18.1577 17.5326 18.3333 17.1087 18.3333 16.6667C18.3333 16.2246 18.1577 15.8007 17.8452 15.4882C17.5326 15.1756 17.1087 15 16.6667 15Z" fill="#356289"/>
      </svg>
    `,
    overdrive: `
      <svg width="37" height="37" viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M34.6544 1.95122C34.6408 1.88547 34.6087 1.82497 34.5618 1.77686C34.515 1.72874 34.4554 1.695 34.39 1.67961C30.033 0.613981 19.968 4.41098 14.5092 9.86572C13.5364 10.8306 12.6493 11.8783 11.858 12.9969C10.1754 12.8447 8.49285 12.9729 7.06026 13.5978C3.01488 15.3765 1.83788 20.022 1.50938 22.0163C1.49158 22.1256 1.49918 22.2375 1.5316 22.3433C1.56401 22.4492 1.62036 22.5462 1.69629 22.6267C1.77222 22.7073 1.86568 22.7693 1.96943 22.808C2.07319 22.8466 2.18444 22.8608 2.29458 22.8496L8.7901 22.1365C8.79456 22.6264 8.82398 23.1158 8.87824 23.6027C8.91214 23.9393 9.0623 24.2535 9.30289 24.4913L11.8179 27.0063C12.0559 27.2471 12.3704 27.3972 12.7073 27.431C13.1913 27.4849 13.6777 27.5143 14.1647 27.5191L13.4524 34.009C13.4413 34.119 13.4556 34.2301 13.4943 34.3337C13.5329 34.4372 13.5949 34.5305 13.6754 34.6064C13.7558 34.6822 13.8526 34.7385 13.9583 34.7709C14.064 34.8033 14.1758 34.811 14.2849 34.7934C16.2799 34.4729 20.9351 33.2959 22.7034 29.2513C23.3283 27.8172 23.4565 26.1434 23.3123 24.4688C24.4342 23.6782 25.4849 22.7911 26.4523 21.8176C31.9311 16.3693 35.704 6.52541 34.6544 1.95122ZM21.5825 14.7596C21.1039 14.2812 20.778 13.6716 20.6459 13.0079C20.5138 12.3442 20.5816 11.6563 20.8405 11.0311C21.0994 10.4059 21.5379 9.87152 22.1005 9.49555C22.6632 9.11959 23.3247 8.91892 24.0013 8.91892C24.678 8.91892 25.3395 9.11959 25.9022 9.49555C26.4648 9.87152 26.9033 10.4059 27.1622 11.0311C27.4211 11.6563 27.4889 12.3442 27.3568 13.0079C27.2247 13.6716 26.8988 14.2812 26.4202 14.7596C26.1028 15.0777 25.7258 15.33 25.3107 15.5022C24.8957 15.6744 24.4507 15.763 24.0013 15.763C23.552 15.763 23.107 15.6744 22.692 15.5022C22.2769 15.33 21.8999 15.0777 21.5825 14.7596Z" stroke="#356289" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M6.43901 25.8428C5.64028 25.9408 4.89721 26.3029 4.32779 26.8715C2.91603 28.2881 2.78223 33.5345 2.78223 33.5345C2.78223 33.5345 8.03185 33.4007 9.44441 31.9874C10.0153 31.4188 10.378 30.6745 10.474 29.8745" stroke="#356289" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    `,
  };

  let step = 0;

  // --- TAMBAHAN BARU: Variable Arah Animasi ---
  let animDir = "next";
  function changePage(delta) {
    const currentContainer = screen.querySelector(".jtq");
    animDir = delta > 0 ? "next" : "prev";
    const exitClass = delta > 0 ? "jtq-exit-next" : "jtq-exit-prev";

    if (currentContainer) {
      currentContainer.classList.add("jtq-anim", exitClass);
      setTimeout(() => {
        step += delta;
        render();
      }, 300);
    } else {
      step += delta;
      render();
    }
  }

  let mobileRankAbort = null;

  const answers = {};
  const startedAt = new Date().toISOString();

  const lead = { name: "", email: "" };
  let leadDone = false;

  function escapeHTML(s) {
    const str = String(s == null ? "" : s);
    return str
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function getPowerTitle(label) {
    const parts = String(label == null ? "" : label).split("—");
    return (parts[0] || "").trim();
  }

  function getPowerDesc(label) {
    const parts = String(label == null ? "" : label).split("—");
    return (parts[1] || "").trim();
  }

  const SINGLE_EMOJIS = ["✨", "🚀", "🌸", "🏯", "📸"];

  const _emojiCache = {};

  function getSingleEmoji(qId, idx) {
    if (!_emojiCache[qId]) {
      const shuffled = [...SINGLE_EMOJIS];
      for (let i = shuffled.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
      }
      _emojiCache[qId] = shuffled;
    }

    const list = _emojiCache[qId];
    const i = Number(idx) || 0;
    return list[i % list.length];
  }

  function initScores() {
    const o = {};
    for (let i = 0; i < PERSONA_KEYS.length; i++) o[PERSONA_KEYS[i]] = 0;
    return o;
  }

  function scoreQuiz() {
    const scores = initScores();
    const rankingWeights = Array.isArray(CFG.rankingWeights)
      ? CFG.rankingWeights
      : [4, 3, 2, 1, 0];

    const meta = {
      rankFirstCount: initScores(),
      chosenPowerup: initScores(),
    };

    for (let i = 0; i < QUESTIONS.length; i++) {
      const q = QUESTIONS[i];
      const a = answers[q.id];
      if (!a) continue;

      if (q.type === "ranking") {
        for (let j = 0; j < a.length; j++) {
          const persona = a[j];
          const w = rankingWeights[j] != null ? rankingWeights[j] : 0;
          scores[persona] += w;
        }
        if (a[0]) meta.rankFirstCount[a[0]] += 1;
      }

      if (q.type === "single") {
        scores[a] += CFG.single != null ? CFG.single : 3;
      }

      if (q.type === "powerup") {
        scores[a] += CFG.powerup != null ? CFG.powerup : 4;
        meta.chosenPowerup[a] += 1;
      }
    }

    const sorted = PERSONA_KEYS.slice().sort((p1, p2) => {
      if (scores[p2] !== scores[p1]) return scores[p2] - scores[p1];
      if (meta.rankFirstCount[p2] !== meta.rankFirstCount[p1])
        return meta.rankFirstCount[p2] - meta.rankFirstCount[p1];
      if (meta.chosenPowerup[p2] !== meta.chosenPowerup[p1])
        return meta.chosenPowerup[p2] - meta.chosenPowerup[p1];
      return 0;
    });

    return { scores, top: sorted[0], second: sorted[1], sorted, meta };
  }

  function setProgress(forceStep) {
    const total = QUESTIONS.length || 1;
    let current =
      typeof forceStep === "number" ? Math.floor(forceStep) : step + 1;
    if (current < 1) current = 1;
    if (current > total) current = total;
    if (progressText) progressText.textContent = `Question ${current}/${total}`;
  }

  function showOverlay(msg) {
    document.documentElement.classList.add("jtq-scroll-locked");
    document.body.classList.add("jtq-scroll-locked");

    const el = document.createElement("div");
    el.className = "jtq__overlay";
    el.innerHTML = `
      <div class="jtq__overlayBox">
        <div class="jtq__spinner"></div>
        <div style="font-weight:800; margin-bottom:6px;">
          ${escapeHTML(msg || "Loading…")}
        </div>
        <div style="opacity:.75; font-size:13px;">
          Mohon tunggu sebentar…
        </div>
      </div>
    `;
    screen.appendChild(el);

    return function hide() {
      if (el && el.parentNode) el.parentNode.removeChild(el);
      document.documentElement.classList.remove("jtq-scroll-locked");
      document.body.classList.remove("jtq-scroll-locked");
    };
  }

  function isMobile() {
    return window.matchMedia("(max-width: 640px)").matches;
  }

  function render() {
    setHeaderVisibility(false);
    setProgress();

    const q = QUESTIONS[step];

    if (!q) {
      if ((ASK_LEAD || REQUIRE_LEAD) && !leadDone) renderLeadForm();
      else renderResult();
      return;
    }

    if (q.type === "ranking") {
      isMobile() ? renderRankingMobile(q) : renderRanking(q);
    } else if (q.type === "powerup") {
      renderPowerUp(q);
    } else {
      renderPickOne(q);
    }

    const newContainer = screen.querySelector(".jtq");
    if (newContainer) {
      const enterClass =
        animDir === "next" ? "jtq-enter-next" : "jtq-enter-prev";
      newContainer.classList.add("jtq-anim", enterClass);
    }
  }

  function renderPickOne(q) {
    const picked = answers[q.id] || "";
    const nextLabel =
      step === QUESTIONS.length - 1 ? "Lihat hasil" : "Lanjut →";
    const groupName = `jtq_q_${q.id}`;

    const shuffledOptions = [...(q.options || [])];
    for (let i = shuffledOptions.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffledOptions[i], shuffledOptions[j]] = [
        shuffledOptions[j],
        shuffledOptions[i],
      ];
    }

    screen.innerHTML = `
      <div class="jtq jtq--single">
        <h3 class="jtq__q">${escapeHTML(q.prompt)}</h3>
        <form class="jtq__form jtq__form--single" autocomplete="off">
          <div class="jtq__opts jtq__opts--single" role="radiogroup" aria-label="${escapeHTML(q.prompt)}">
            ${shuffledOptions
              .map((opt, idx) => {
                const id = `jtq_${q.id}_${idx}`;
                const checked = picked === opt.persona ? "checked" : "";
                const emoji = getSingleEmoji(q.id, idx);

                return `
                  <label class="jtq__choice jtq__choice--single">
                    <input class="jtq__radio jtq__radio--single" type="radio" id="${escapeHTML(id)}" name="${escapeHTML(
                      groupName,
                    )}" value="${escapeHTML(opt.persona)}" ${checked} />
                    <span class="jtq__opt">
                      <span class="jtq__label">
                        <span class="jtq__emoji" aria-hidden="true">${escapeHTML(emoji)}</span>
                        ${escapeHTML(opt.label)}
                      </span>
                    </span>
                  </label>
                `;
              })
              .join("")}
          </div>
        </form>
        <div class="jtq__nav">
          ${step > 0 ? `<button type="button" class="jtq__back">← Kembali</button>` : `<span></span>`}
          <button type="button" class="jtq__next" ${picked ? "" : "disabled"}>${nextLabel}</button>
        </div>
      </div>
    `;

    const next = screen.querySelector(".jtq__next");
    const radios = screen.querySelectorAll(`input[name="${groupName}"]`);

    radios.forEach((r) => {
      r.addEventListener("change", () => {
        answers[q.id] = r.value || "";
        if (AUTO_NEXT) {
          changePage(1);
        } else {
          next.disabled = !answers[q.id];
        }
      });
    });

    const back = screen.querySelector(".jtq__back");
    if (back) back.addEventListener("click", () => changePage(-1));

    next.addEventListener("click", () => {
      if (!answers[q.id]) return;
      changePage(1);
    });
  }

  function renderPowerUp(q) {
    const picked = answers[q.id] || "";
    const nextLabel =
      step === QUESTIONS.length - 1 ? "Lihat hasil" : "Lanjut →";
    const groupName = `jtq_q_${q.id}`;

    const shouldShuffle = String(q.id) !== "7";
    const options = shouldShuffle ? [...(q.options || [])] : q.options || [];

    if (shouldShuffle) {
      for (let i = options.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [options[i], options[j]] = [options[j], options[i]];
      }
    }

    screen.innerHTML = `
      <div class="jtq jtq--power">
        <h3 class="jtq__q">${escapeHTML(q.prompt)}</h3>
        <form class="jtq__form jtq__form--power" autocomplete="off">
          <div class="jtq__powerGrid jtq__opts--power" role="radiogroup" aria-label="${escapeHTML(q.prompt)}">
            ${options
              .map((opt, idx) => {
                const id = `jtq_${q.id}_${idx}`;
                const checked = picked === opt.persona ? "checked" : "";

                let icon = POWER_ICONS[opt.iconKey] || "";

                if (String(q.id) === "7") {
                  const Q7_ICONS = [
                    "lock",
                    "reset",
                    "emotional",
                    "stamina",
                    "overdrive",
                  ];
                  icon = POWER_Q7_ICON_MAP[Q7_ICONS[idx]] || "";
                }

                return `
                  <label class="jtq__choice--power" for="${escapeHTML(id)}">
                    <input class="jtq__radio jtq__radio--power" type="radio" id="${escapeHTML(id)}" name="${escapeHTML(
                      groupName,
                    )}" value="${escapeHTML(opt.persona)}" ${checked} />
                    <span class="jtq__powerCard">
                      <span class="jtq__powerIcon">${icon}</span>
                      <span class="jtq__powerTitle">${escapeHTML(getPowerTitle(opt.label))}</span>
                      <span class="jtq__powerDesc">${escapeHTML(getPowerDesc(opt.label))}</span>
                    </span>
                  </label>
                `;
              })
              .join("")}
          </div>
        </form>
        <div class="jtq__nav">
          ${step > 0 ? `<button type="button" class="jtq__back">← Kembali</button>` : `<span></span>`}
          <button type="button" class="jtq__next" ${picked ? "" : "disabled"}>${nextLabel}</button>
        </div>
      </div>
    `;

    const next = screen.querySelector(".jtq__next");
    const radios = screen.querySelectorAll(`input[name="${groupName}"]`);

    radios.forEach((r) => {
      r.addEventListener("change", () => {
        answers[q.id] = r.value || "";
        if (AUTO_NEXT) {
          changePage(1);
        } else {
          next.disabled = !answers[q.id];
        }
      });
    });

    const back = screen.querySelector(".jtq__back");
    if (back) back.addEventListener("click", () => changePage(-1));

    next.addEventListener("click", () => {
      if (!answers[q.id]) return;
      changePage(1);
    });
  }

  function renderRanking(q) {
    const slotsCount = (q.options || []).length;
    const current = Array.isArray(answers[q.id]) ? answers[q.id] : [];
    const optByPersona = {};
    (q.options || []).forEach((o) => (optByPersona[o.persona] = o));

    function ghostItemHTML(no) {
      return `
        <li class="jtq-rank__item jtq-rank__item--ghost">
          <span class="jtq-rank__ghostText">Option #${no}</span>
        </li>
      `;
    }

    // --- LOGIKA HINT TEXT DINAMIS ---
    let rankHint = "";
    const qId = String(q.id);

    if (qId === "1") {
      rankHint =
        "Urutkan berdasarkan prioritas. Yang paling penting buat kamu, letakkan di posisi paling atas.";
    } else if (qId === "5") {
      rankHint =
        "Urutkan dari tingkat stressnya. Yang paling bikin kamu stress atau emosi selama liburan, taruh di posisi paling atas.";
    } else if (qId === "9") {
      rankHint =
        "Urutkan berdasarkan tingkat kepuasanmu. Mana hasil yang paling bikin puas selama liburan menurutmu, letakkan di posisi paling atas.";
    } else {
      rankHint =
        CFG.rankHint ||
        "Susun pilihan dari yang paling menggambarkan kamu di posisi paling atas.";
    }

    screen.innerHTML = `
      <div class="jtq">
        <h3 class="jtq__q">${escapeHTML(q.prompt)}</h3>
        <p class="jtq__hint jtq__hint--rank">${escapeHTML(rankHint)}</p>

        <div class="jtq-rank">
          <section class="jtq-rank__panel">
            <ul id="jtqSourceList" class="jtq-rank__list" aria-label="Daftar item">
              ${(() => {
                const rows = [];
                const used = new Set(current.filter(Boolean));
                q.options.forEach((opt, index) => {
                  const persona = opt.persona;
                  if (!used.has(persona)) {
                    rows.push(
                      rankItemHTML(
                        persona,
                        optByPersona[persona]?.label || "",
                        "li",
                      ),
                    );
                  } else {
                    rows.push(ghostItemHTML(index + 1));
                  }
                });
                return rows.join("");
              })()}
            </ul>
          </section>

          <section class="jtq-rank__panel">
            <ul id="jtqPriorityList" class="jtq-rank__slots" aria-label="Slot prioritas">
              ${Array.from({ length: slotsCount })
                .map((_, i) => {
                  const slotNo = i + 1;
                  const persona = current[i];
                  return slotHTML(
                    slotNo,
                    persona,
                    persona && optByPersona[persona]
                      ? optByPersona[persona].label
                      : "",
                  );
                })
                .join("")}
            </ul>

            <div class="jtq__error" id="jtqRankError" style="display:none;"></div>
          </section>
        </div>

        <div class="jtq__nav">
          ${step > 0 ? `<button type="button" class="jtq__back">← Kembali</button>` : `<span></span>`}
          <button type="button" class="jtq__next" id="jtqRankNext" disabled>Lanjut →</button>
        </div>
      </div>
    `;

    const rankWrap = screen.querySelector(".jtq-rank");
    const sourceList = screen.querySelector("#jtqSourceList");
    const sourcePanel = sourceList.closest(".jtq-rank__panel");
    const slots = [].slice.call(screen.querySelectorAll(".jtq-rank__slot"));
    const nextBtn = screen.querySelector("#jtqRankNext");

    let draggedEl = null;
    let tapped = null;

    function rankItemHTML(persona, label, tag = "li") {
      return `
        <${tag} class="jtq-rank__item" draggable="true" data-persona="${escapeHTML(persona)}">
          <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.25 6.875C8.61467 6.875 8.96441 6.73013 9.22227 6.47227C9.48013 6.21441 9.625 5.86467 9.625 5.5C9.625 5.13533 9.48013 4.78559 9.22227 4.52773C8.96441 4.26987 8.61467 4.125 8.25 4.125C7.88533 4.125 7.53559 4.26987 7.27773 4.52773C7.01987 4.78559 6.875 5.13533 6.875 5.5C6.875 5.86467 7.01987 6.21441 7.27773 6.47227C7.53559 6.73013 7.88533 6.875 8.25 6.875ZM8.25 12.375C8.61467 12.375 8.96441 12.2301 9.22227 11.9723C9.48013 11.7144 9.625 11.3647 9.625 11C9.625 10.6353 9.48013 10.2856 9.22227 10.0277C8.96441 9.76987 8.61467 9.625 8.25 9.625C7.88533 9.625 7.53559 9.76987 7.27773 10.0277C7.01987 10.2856 6.875 10.6353 6.875 11C6.875 11.3647 7.01987 11.7144 7.27773 11.9723C7.53559 12.2301 7.88533 12.375 8.25 12.375ZM9.625 16.5C9.625 16.8647 9.48013 17.2144 9.22227 17.4723C8.96441 17.7301 8.61467 17.875 8.25 17.875C7.88533 17.875 7.53559 17.7301 7.27773 17.4723C7.01987 17.2144 6.875 16.8647 6.875 16.5C6.875 16.1353 7.01987 15.7856 7.27773 15.5277C7.53559 15.2699 7.88533 15.125 8.25 15.125C8.61467 15.125 8.96441 15.2699 9.22227 15.5277C9.48013 15.7856 9.625 16.1353 9.625 16.5ZM13.75 6.875C14.1147 6.875 14.4644 6.73013 14.7223 6.47227C14.9801 6.21441 15.125 5.86467 15.125 5.5C15.125 5.13533 14.9801 4.78559 14.7223 4.52773C14.4644 4.26987 14.1147 4.125 13.75 4.125C13.3853 4.125 13.0356 4.26987 12.7777 4.52773C12.5199 4.78559 12.375 5.13533 12.375 5.5C12.375 5.86467 12.5199 6.21441 12.7777 6.47227C13.0356 6.73013 13.3853 6.875 13.75 6.875ZM15.125 11C15.125 11.3647 14.9801 11.7144 14.7223 11.9723C14.4644 12.2301 14.1147 12.375 13.75 12.375C13.3853 12.375 13.0356 12.2301 12.7777 11.9723C12.5199 11.7144 12.375 11.3647 12.375 11C12.375 10.6353 12.5199 10.2856 12.7777 10.0277C13.0356 9.76987 13.3853 9.625 13.75 9.625C14.1147 9.625 14.4644 9.76987 14.7223 10.0277C14.9801 10.2856 15.125 10.6353 15.125 11ZM13.75 17.875C14.1147 17.875 14.4644 17.7301 14.7223 17.4723C14.9801 17.2144 15.125 16.8647 15.125 16.5C15.125 16.1353 14.9801 15.7856 14.7223 15.5277C14.4644 15.2699 14.1147 15.125 13.75 15.125C13.3853 15.125 13.0356 15.2699 12.7777 15.5277C12.5199 15.7856 12.375 16.1353 12.375 16.5C12.375 16.8647 12.5199 17.2144 12.7777 17.4723C13.0356 17.7301 13.3853 17.875 13.75 17.875Z" fill="black" fill-opacity="0.2"/>
          </svg>
          <span class="jtq-rank__label">
            <span class="jtq-rank__dot"></span>
            <span class="jtq-rank__text">${escapeHTML(label || "")}</span>
          </span>
        </${tag}>
      `;
    }

    // Helper untuk menentukan teks placeholder berdasarkan ID pertanyaan
    function getPlaceholderText(no) {
      const qId = String(q.id);
      if (qId === "5") {
        const stress = [
          "Paling bikin stres",
          "Cukup bikin stres",
          "Lumayan ganggu",
          "Gak terlalu ganggu",
          "Biasa aja",
        ];
        return stress[no - 1] || `Priority #${no}`;
      }
      if (qId === "9") {
        const satisfied = [
          "Paling puas",
          "Cukup puas",
          "Lumayan puas",
          "Biasa aja",
          "Gak puas",
        ];
        return satisfied[no - 1] || `Priority #${no}`;
      }
      return `Priority #${no}`;
    }

    function slotHTML(slotNo, persona, label) {
      if (!persona) {
        return `
          <li class="jtq-rank__slot" data-slot="${slotNo}">
            <span class="jtq-rank__placeholder">${getPlaceholderText(slotNo)}</span>
          </li>
        `;
      }
      return `
        <li class="jtq-rank__slot jtq-rank__slot--filled" data-slot="${slotNo}">
          ${rankItemHTML(persona, label, "div")}
        </li>
      `;
    }

    function createItemFrom(itemEl, tag = "li") {
      const persona = itemEl.getAttribute("data-persona") || "";
      const labelEl = itemEl.querySelector(".jtq-rank__text");
      const label = labelEl ? labelEl.textContent : "";
      const tmp = document.createElement("div");
      tmp.innerHTML = rankItemHTML(persona, label, tag).trim();
      const el = tmp.firstElementChild;
      const badge = el.querySelector(".jtq-rank__rankNo");
      if (badge) badge.remove();
      bindDraggable(el);
      bindTapFallback(el);
      return el;
    }

    function emptySlot(slotEl) {
      const no = slotEl.getAttribute("data-slot");
      slotEl.classList.remove("jtq-rank__slot--filled");
      slotEl.innerHTML = `<span class="jtq-rank__placeholder">${getPlaceholderText(no)}</span>`;
    }

    function fillSlot(slotEl, itemEl) {
      slotEl.innerHTML = "";
      slotEl.appendChild(itemEl);
      slotEl.classList.add("jtq-rank__slot--filled");
      bindReturnOnClick(itemEl);
    }

    function getSlotItem(slotEl) {
      return slotEl.querySelector(".jtq-rank__item");
    }
    function setHover(el, on) {
      if (el) el.classList.toggle("jtq-rank__hover", !!on);
    }
    function clearTapped() {
      const t = screen.querySelectorAll(".jtq-rank__tapped");
      for (let i = 0; i < t.length; i++)
        t[i].classList.remove("jtq-rank__tapped");
      tapped = null;
    }

    function syncRanking() {
      const ranking = [];
      let ok = true;
      slots.forEach((slot, i) => {
        const item = getSlotItem(slot);
        if (!item) {
          ok = false;
          return;
        }
        const persona = item.dataset.persona;
        ranking.push(persona);
        let badge = item.querySelector(".jtq-rank__rankNo");
        if (!badge) {
          badge = document.createElement("span");
          badge.className = "jtq-rank__rankNo";
          item.appendChild(badge);
        }
        badge.textContent = i + 1;
      });

      sourceList.innerHTML = "";
      q.options.forEach((opt, index) => {
        const isUsed = ranking.includes(opt.persona);
        if (!isUsed) {
          const tmp = document.createElement("div");
          tmp.innerHTML = rankItemHTML(opt.persona, opt.label, "li").trim();
          const li = tmp.firstElementChild;
          const badge = li.querySelector(".jtq-rank__rankNo");
          if (badge) badge.remove();
          bindDraggable(li);
          bindTapFallback(li);
          sourceList.appendChild(li);
        } else {
          const ghost = document.createElement("li");
          ghost.className = "jtq-rank__item jtq-rank__item--ghost";
          ghost.innerHTML = `<span class="jtq-rank__ghostText">Option #${index + 1}</span>`;
          sourceList.appendChild(ghost);
        }
      });

      if (ok) {
        answers[q.id] = ranking;
        nextBtn.disabled = false;
      } else {
        delete answers[q.id];
        nextBtn.disabled = true;
      }
    }

    function bindDraggable(item) {
      item.addEventListener("dragstart", (e) => {
        draggedEl = item;
        item.classList.add("jtq-rank__dragging");
        e.dataTransfer.setData(
          "text/plain",
          item.getAttribute("data-persona") || "",
        );
        e.dataTransfer.effectAllowed = "move";
      });
      item.addEventListener("dragend", () => {
        item.classList.remove("jtq-rank__dragging");
        draggedEl = null;
        const h = screen.querySelectorAll(".jtq-rank__hover");
        for (let i = 0; i < h.length; i++)
          h[i].classList.remove("jtq-rank__hover");
      });
    }

    function bindTapFallback(item) {
      item.addEventListener("click", () => {
        if (tapped === item) {
          item.classList.remove("jtq-rank__tapped");
          tapped = null;
        } else {
          clearTapped();
          item.classList.add("jtq-rank__tapped");
          tapped = item;
        }
      });
    }

    function bindReturnOnClick(item) {
      item.addEventListener("click", (e) => {
        e.stopPropagation();
        if (tapped === item) return;
        clearTapped();
        item.classList.add("jtq-rank__tapped");
        tapped = item;
      });
    }

    sourcePanel.addEventListener("click", (e) => {
      if (!tapped) return;
      const fromSlot = tapped.closest(".jtq-rank__slot");
      if (!fromSlot) return;
      const clickedItem = e.target.closest(".jtq-rank__item");
      if (clickedItem && clickedItem.closest("#jtqSourceList")) return;
      const newItem = createItemFrom(tapped, "li");
      sourceList.appendChild(newItem);
      emptySlot(fromSlot);
      tapped.classList.remove("jtq-rank__tapped");
      tapped = null;
      syncRanking();
    });

    slots.forEach((slot) => {
      const item = slot.querySelector(".jtq-rank__item");
      if (item) bindReturnOnClick(item);
    });

    sourceList.addEventListener("dragover", (e) => {
      e.preventDefault();
      setHover(sourceList, true);
      e.dataTransfer.dropEffect = "move";
    });
    sourceList.addEventListener("dragleave", () => setHover(sourceList, false));
    sourceList.addEventListener("drop", (e) => {
      e.preventDefault();
      setHover(sourceList, false);
      if (!draggedEl) return;
      const fromSlot = draggedEl.closest(".jtq-rank__slot");
      if (fromSlot) {
        const newItem = createItemFrom(draggedEl, "li");
        sourceList.appendChild(newItem);
        emptySlot(fromSlot);
        syncRanking();
      }
    });

    for (let i = 0; i < slots.length; i++) {
      const slotEl = slots[i];
      slotEl.addEventListener("dragover", (e) => {
        e.preventDefault();
        setHover(slotEl, true);
        e.dataTransfer.dropEffect = "move";
      });
      slotEl.addEventListener("dragleave", () => setHover(slotEl, false));
      slotEl.addEventListener("drop", (e) => {
        e.preventDefault();
        setHover(slotEl, false);
        if (!draggedEl) return;
        const targetSlot = slotEl;
        const targetHasItem = getSlotItem(targetSlot);
        const fromSlot = draggedEl.closest(".jtq-rank__slot");
        const fromSource = draggedEl.closest("#jtqSourceList");

        if (fromSource) {
          const newItem = createItemFrom(draggedEl, "div");
          if (targetHasItem) {
            const backItem = createItemFrom(targetHasItem, "li");
            sourceList.appendChild(backItem);
          }
          fillSlot(targetSlot, newItem);
          draggedEl.parentNode && draggedEl.parentNode.removeChild(draggedEl);
          syncRanking();
          return;
        }
        if (fromSlot) {
          if (fromSlot === targetSlot) return;
          const movingItem = draggedEl;
          if (targetHasItem) {
            fromSlot.innerHTML = "";
            fromSlot.appendChild(targetHasItem);
            fromSlot.classList.add("jtq-rank__slot--filled");
          } else {
            emptySlot(fromSlot);
          }
          fillSlot(targetSlot, movingItem);
          syncRanking();
          return;
        }
      });

      slotEl.addEventListener("click", () => {
        if (!tapped) return;
        const targetSlot = slotEl;
        const targetHasItem = getSlotItem(targetSlot);
        const fromSlot = tapped.closest(".jtq-rank__slot");
        const fromSource = tapped.closest("#jtqSourceList");

        if (fromSource) {
          const newItem = createItemFrom(tapped, "div");
          if (targetHasItem) {
            const backItem = createItemFrom(targetHasItem, "li");
            sourceList.appendChild(backItem);
          }
          fillSlot(targetSlot, newItem);
          tapped.parentNode && tapped.parentNode.removeChild(tapped);
        }
        if (fromSlot) {
          if (fromSlot === targetSlot) {
            tapped.classList.remove("jtq-rank__tapped");
            tapped = null;
            return;
          }
          const movingItem = tapped;
          if (targetHasItem) {
            fromSlot.innerHTML = "";
            fromSlot.appendChild(targetHasItem);
            fromSlot.classList.add("jtq-rank__slot--filled");
          } else {
            emptySlot(fromSlot);
          }
          fillSlot(targetSlot, movingItem);
        }
        clearTapped();
        syncRanking();
      });
    }

    const items = screen.querySelectorAll(".jtq-rank__item[draggable='true']");
    for (let i = 0; i < items.length; i++) {
      bindDraggable(items[i]);
      bindTapFallback(items[i]);
    }

    const back = screen.querySelector(".jtq__back");
    if (back) back.addEventListener("click", () => changePage(-1));

    nextBtn.addEventListener("click", () => {
      if (nextBtn.disabled) return;
      changePage(1);
    });

    syncRanking();
  }

  function renderRankingMobile(q) {
    const current = Array.isArray(answers[q.id]) ? answers[q.id] : [];
    const opts = q.options || [];
    const ordered = current.length
      ? current.map((p) => opts.find((o) => o.persona === p)).filter(Boolean)
      : [...opts];

    // --- LOGIKA HINT TEXT DINAMIS (MOBILE) ---
    const qId = String(q.id);
    let HINT_BEFORE = "";
    let HINT_AFTER = "";

    if (qId === "1") {
      HINT_BEFORE =
        "Pilihlah secara berurutan yang menurutmu paling prioritas.";
      HINT_AFTER =
        "Urutkan berdasarkan prioritas. Yang paling penting buat kamu, letakkan di posisi paling atas.";
    } else if (qId === "5") {
      HINT_BEFORE =
        "Pilihlah secara berurutan yang paling membuatmu stress selama liburan.";
      HINT_AFTER =
        "Urutkan dari tingkat stressnya. Yang paling bikin kamu stress atau emosi selama liburan, taruh di posisi paling atas.";
    } else if (qId === "9") {
      HINT_BEFORE = "Pilihlah secara berurutan yang paling bikin kamu puas.";
      HINT_AFTER =
        "Urutkan berdasarkan tingkat kepuasanmu. Mana hasil yang paling bikin puas selama liburan menurutmu, letakkan di posisi paling atas.";
    } else {
      // Default
      HINT_BEFORE = "Pilih satu per satu sesuai yang paling kamu rasakan dulu.";
      HINT_AFTER =
        "Susun pilihan dari yang paling menggambarkan kamu di posisi paling atas.";
    }

    if (mobileRankAbort) mobileRankAbort.abort();
    mobileRankAbort = new AbortController();
    const { signal } = mobileRankAbort;

    screen.innerHTML = `
      <div class="jtq jtq--rank-mobile" id="jtqRankMobileWrap">
        <h3 class="jtq__q">${escapeHTML(q.prompt)}</h3>
        <p class="jtq__hint" id="jtqRankMobileHint">${escapeHTML(HINT_BEFORE)}</p>

        <ul class="jtq-rank_list" id="jtqMobileRankList">
          ${ordered
            .map(
              (o) => `
            <li class="jtq-rank_item" data-persona="${escapeHTML(o.persona)}">
              <span class="jtq-rank_index"></span>
              <span class="jtq-rank_label">${escapeHTML(o.label)}</span>
              <span class="jtq-rank_handle">
                <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
                  <circle cx="8.25" cy="5.5" r="1.5" fill="black" fill-opacity="0.5"/>
                  <circle cx="8.25" cy="11" r="1.5" fill="black" fill-opacity="0.5"/>
                  <circle cx="8.25" cy="16.5" r="1.5" fill="black" fill-opacity="0.5"/>
                  <circle cx="13.75" cy="5.5" r="1.5" fill="black" fill-opacity="0.5"/>
                  <circle cx="13.75" cy="11" r="1.5" fill="black" fill-opacity="0.5"/>
                  <circle cx="13.75" cy="16.5" r="1.5" fill="black" fill-opacity="0.5"/>
                </svg>
              </span>
            </li>
          `,
            )
            .join("")}
        </ul>

        <div class="jtq__nav">
          ${step > 0 ? `<button class="jtq__back">← Kembali</button>` : `<span></span>`}
          <button class="jtq__next">Lanjut →</button>
        </div>
      </div>
    `;

    const list = screen.querySelector("#jtqMobileRankList");
    const nextBtn = screen.querySelector(".jtq__next");
    const backBtn = screen.querySelector(".jtq__back");
    const hintEl = screen.querySelector("#jtqRankMobileHint");

    const getItems = () => [...list.querySelectorAll(".jtq-rank_item")];

    let indexesShown = false;
    let clickQueue = [];
    let clickLocked = false;

    function setNextEnabled(enabled) {
      nextBtn.disabled = !enabled;
      nextBtn.classList.toggle("is-disabled", !enabled);
    }

    function isAllSelected() {
      return clickQueue.length === opts.length;
    }

    function updateListState() {
      list.classList.toggle("all-active", isAllSelected());
    }

    function updateNextState() {
      setNextEnabled(indexesShown && isAllSelected());
      updateListState();
    }

    function syncAnswers() {
      answers[q.id] = getItems().map((el) => el.dataset.persona);
    }

    function updateHint() {
      if (!hintEl) return;
      hintEl.textContent = isAllSelected() ? HINT_AFTER : HINT_BEFORE;
    }

    function showIndexesOnce() {
      if (indexesShown) return;
      indexesShown = true;
      updateIndexes();
    }

    function updateIndexes() {
      if (!indexesShown) return;

      const items = getItems();
      let no = 0;

      for (let el of items) {
        const p = el.dataset.persona;
        const idxEl = el.querySelector(".jtq-rank_index");
        const selected = clickQueue.includes(p);

        el.classList.toggle("has-index", selected);

        if (selected) {
          no++;
          if (idxEl) idxEl.textContent = String(no);
        } else {
          if (idxEl) idxEl.textContent = "";
        }
      }
    }

    function applyActiveState() {
      const items = getItems();
      for (let el of items) {
        const p = el.dataset.persona;
        const idx = clickQueue.indexOf(p);
        el.classList.toggle("is-active", idx !== -1);
        el.classList.toggle(
          "is-current",
          idx === clickQueue.length - 1 && idx !== -1,
        );
      }
    }

    function commitClickSelect(item) {
      if (clickLocked) return;

      const persona = item.dataset.persona;
      if (!persona) return;

      if (!clickQueue.includes(persona)) clickQueue.push(persona);

      const pos = clickQueue.length - 1;
      const target = list.children[pos];

      if (target !== item) {
        if (target) list.insertBefore(item, target);
        else list.appendChild(item);
      }

      showIndexesOnce();
      applyActiveState();
      updateIndexes();
      syncAnswers();

      if (isAllSelected()) clickLocked = true;

      updateHint();
      updateNextState();
    }

    function hydrateFromSavedAnswer() {
      const saved = Array.isArray(answers[q.id]) ? answers[q.id] : [];

      if (!saved.length) {
        updateNextState();
        return;
      }

      clickQueue = saved.slice();
      indexesShown = true;
      clickLocked = saved.length >= opts.length;

      const map = new Map();
      getItems().forEach((el) => map.set(el.dataset.persona, el));

      const orderedEls = [];
      for (let p of saved) {
        const el = map.get(p);
        if (el) orderedEls.push(el);
      }

      getItems().forEach((el) => {
        if (!saved.includes(el.dataset.persona)) orderedEls.push(el);
      });

      orderedEls.forEach((el) => list.appendChild(el));

      applyActiveState();
      updateIndexes();
      updateHint();
      updateNextState();
    }

    setNextEnabled(false);
    hydrateFromSavedAnswer();

    /* =========================
      FIXED DRAG ARCHITECTURE
    ========================== */

    let candidate = null;
    let dragging = null;
    let ghost = null;
    let offsetY = 0;
    const DRAG_THRESHOLD = 6;

    function createGhost(el, y) {
      const r = el.getBoundingClientRect();
      const g = el.cloneNode(true);
      g.classList.add("jtq-rank_ghost");
      g.style.position = "fixed";
      g.style.left = r.left + "px";
      g.style.top = r.top + "px";
      g.style.width = r.width + "px";
      g.style.pointerEvents = "none";
      document.body.appendChild(g);
      return { el: g, offsetY: y - r.top };
    }

    function getInsertBeforeElement(y) {
      const items = getItems().filter((el) => el !== dragging);
      for (const el of items) {
        const r = el.getBoundingClientRect();
        if (y < r.top + r.height / 2) return el;
      }
      return null;
    }

    /* SELECT VIA CLICK */
    list.addEventListener("click", (e) => {
      const item = e.target.closest(".jtq-rank_item");
      if (!item) return;
      if (e.target.closest(".jtq-rank_handle")) return;
      if (isAllSelected()) return;
      commitClickSelect(item);
    });

    /* DRAG ONLY FROM HANDLE */
    list.addEventListener("pointerdown", (e) => {
      const handle = e.target.closest(".jtq-rank_handle");
      if (!handle) return;
      if (!isAllSelected()) return;

      const item = handle.closest(".jtq-rank_item");
      if (!item) return;

      candidate = {
        item,
        startX: e.clientX,
        startY: e.clientY,
        pointerId: e.pointerId,
      };

      try {
        item.setPointerCapture(e.pointerId);
      } catch (_) {}

      e.preventDefault();
    });

    window.addEventListener(
      "pointermove",
      (e) => {
        if (!candidate) return;

        const dx = e.clientX - candidate.startX;
        const dy = e.clientY - candidate.startY;

        if (!dragging) {
          if (Math.hypot(dx, dy) < DRAG_THRESHOLD) return;

          dragging = candidate.item;
          dragging.classList.add("jtq-rank_dragging");

          const g = createGhost(dragging, e.clientY);
          ghost = g.el;
          offsetY = g.offsetY;

          e.preventDefault();
        }

        if (!dragging || !ghost) return;

        ghost.style.top = e.clientY - offsetY + "px";

        const before = getInsertBeforeElement(e.clientY);
        if (before) list.insertBefore(dragging, before);
        else list.appendChild(dragging);

        e.preventDefault();
      },
      { passive: false, signal },
    );

    window.addEventListener(
      "pointerup",
      () => {
        if (!candidate) return;

        if (ghost) ghost.remove();
        if (dragging) dragging.classList.remove("jtq-rank_dragging");

        ghost = null;
        dragging = null;
        candidate = null;

        applyActiveState();
        updateIndexes();
        syncAnswers();
        updateNextState();
      },
      { passive: true, signal },
    );

    // --- BAGIAN INI SAJA YANG DIUBAH ---
    nextBtn.addEventListener("click", () => {
      if (nextBtn.disabled) return;
      syncAnswers();
      changePage(1); // Animasi Next
    });

    if (backBtn) {
      backBtn.addEventListener("click", () => {
        changePage(-1); // Animasi Back
      });
    }
  }
  function renderLeadForm() {
    setHeaderVisibility(false);
    setProgress(QUESTIONS.length);

    screen.innerHTML = `
      <div class="jtq">
        <h3 class="jtq__q">Sebelum lihat hasil…</h3>
        <p class="jtq__hint">Isi nama & email untuk melanjutkan.</p>

        <div class="jtq__field">
          <div class="jtq__labelText">Nama Lengkap</div>
          <input class="jtq__input" id="jtqLeadName" type="text" placeholder="Nama Lengkap" value="${escapeHTML(
            lead.name,
          )}" />
        </div>

        <div class="jtq__field">
          <div class="jtq__labelText">Email</div>
          <input class="jtq__input" id="jtqLeadEmail" type="email" placeholder="emailanda@mail.com" value="${escapeHTML(
            lead.email,
          )}" />
        </div>

        <div class="jtq__error" id="jtqLeadErr" style="display:none;"></div>

        <div class="jtq__nav">
          <button type="button" class="jtq__back" id="jtqLeadBack">← Kembali</button>
          <button type="button" class="jtq__next" id="jtqLeadSubmit" disabled>Submit & Lihat Hasil</button>
        </div>
      </div>
    `;

    const nameEl = screen.querySelector("#jtqLeadName");
    const emailEl = screen.querySelector("#jtqLeadEmail");
    const errEl = screen.querySelector("#jtqLeadErr");
    const submitBtn = screen.querySelector("#jtqLeadSubmit");

    function setErr(msg) {
      if (!msg) {
        errEl.style.display = "none";
        errEl.textContent = "";
        return;
      }
      errEl.textContent = msg;
      errEl.style.display = "block";
    }

    function validEmailLocal(email) {
      const s = String(email || "").trim();
      return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i.test(s);
    }

    function updateSubmitState() {
      const name = String(nameEl.value || "").trim();
      const email = String(emailEl.value || "").trim();

      const ok = name.length > 0 && email.length > 0 && validEmailLocal(email);
      submitBtn.disabled = !ok;

      if (!name && !email) {
        setErr("");
        return;
      }
      if (!name) return setErr("Nama wajib diisi.");
      if (!email) return setErr("Email wajib diisi.");
      if (!validEmailLocal(email)) return setErr("Format email tidak valid.");
      setErr("");
    }

    updateSubmitState();
    nameEl.addEventListener("input", updateSubmitState);
    emailEl.addEventListener("input", updateSubmitState);

    screen.querySelector("#jtqLeadBack").addEventListener("click", () => {
      step = Math.max(QUESTIONS.length - 1, 0);
      render();
    });

    submitBtn.addEventListener("click", async () => {
      if (submitBtn.disabled) return;

      const name = String(nameEl.value || "").trim();
      const email = String(emailEl.value || "").trim();

      lead.name = name;
      lead.email = email;

      if (!name || !email || !validEmailLocal(email)) return;

      leadDone = true;
      await renderResult();
    });
  }

  async function submitToGAS(payload) {
    const BASE_URL =
      CFG.gasUrl ||
      "https://script.google.com/macros/s/AKfycbyBuSOMX5gA84DIH0Nz7dCHW4l-j5JXkPF4-igulelxI4iL4GCfsi9y1bLLcfkDyzwP/exec";
    const TOKEN = CFG.gasToken || "jtpersonaquiz_ah759lsk0j42hcft79l1c_2026";

    if (!BASE_URL || !TOKEN) return { ok: false, skipped: true };

    const url = BASE_URL + "?token=" + encodeURIComponent(TOKEN);
    const body = new URLSearchParams({
      payload: JSON.stringify(payload),
    }).toString();

    const resp = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      },
      body,
    });

    const text = await resp.text();
    try {
      return JSON.parse(text);
    } catch (e) {
      return { ok: resp.ok, status: resp.status, text };
    }
  }

  function buildAdminFriendlyAnswers() {
    const out = [];
    for (let i = 0; i < QUESTIONS.length; i++) {
      const q = QUESTIONS[i];
      const a = answers[q.id];
      if (!a) continue;

      const prompt = String(q.prompt || "Q" + q.id).trim();

      if (q.type === "single" || q.type === "powerup") {
        const opt = (q.options || []).find((o) => o.persona === a);
        out.push({
          id: String(q.id),
          type: q.type,
          prompt,
          value: opt ? opt.label : String(a),
        });
        continue;
      }

      if (q.type === "ranking") {
        const ranks = (Array.isArray(a) ? a : []).map((persona) => {
          const opt = (q.options || []).find((o) => o.persona === persona);
          return opt ? opt.label : String(persona);
        });
        out.push({ id: String(q.id), type: "ranking", prompt, ranks });
      }
    }
    return out;
  }

  function getPersonaField(key, field, fallback) {
    const p = PERSONAS && PERSONAS[key] ? PERSONAS[key] : null;
    const v = p && p[field] != null ? p[field] : null;
    return v != null && v !== "" ? v : fallback;
  }

  function listHTML(items) {
    const arr = Array.isArray(items) ? items : [];
    if (!arr.length) return `<li class="jtq-res__empty">—</li>`;
    return arr.map((t) => `<li>${escapeHTML(t)}</li>`).join("");
  }

  async function renderResult() {
    root.classList.add("is-result");
    setHeaderVisibility(true);
    setProgress(QUESTIONS.length);

    const res = scoreQuiz();
    const topKey = res.top;
    const secondKey = res.second;
    const topName = getPersonaField(topKey, "name", topKey);
    const topSubtitle = getPersonaField(topKey, "subtitle", "");
    const topDesc = getPersonaField(topKey, "description", "");
    const topImg = getPersonaField(topKey, "image", "");
    const topIconUrl = getPersonaField(topKey, "iconUrl", "");
    const secondName = getPersonaField(secondKey, "name", secondKey);
    const secondSubtitle = getPersonaField(secondKey, "subtitle", "");
    const secondImgSmall = getPersonaField(secondKey, "imageSmall", "");
    const secondIconUrl = getPersonaField(secondKey, "iconUrl", "");
    const strengths = getPersonaField(topKey, "strengths", []);
    const travelStyle = getPersonaField(topKey, "travelStyle", []);

    const payload = {
      session_id: sessionId,
      lead: { name: lead.name || "", email: lead.email || "" },
      admin_answers: buildAdminFriendlyAnswers(),
      raw: {
        started_at: startedAt,
        finished_at: new Date().toISOString(),
        answers,
        result: { top: res.top, second: res.second, scores: res.scores },
        meta: { ua: navigator.userAgent, ref: document.referrer },
      },
    };

    const hide = showOverlay("Menyimpan jawaban & menampilkan hasil...");
    await submitToGAS(payload);
    hide();

    screen.innerHTML = `
      <div class="jtq jtq-res">
        <div class="jtq-res__hero">
          <div class="jtq-res__leadText">
            <div class="jtq-res__kicker">Kalau kamu karakter <em>iconic</em> Jepang,</div>
            <div class="jtq-res__kicker">kamu adalah:</div>
          </div>

          <div class="jtq-res__heroArt">
            ${
              topImg
                ? `<img class="jtq-res__img" src="${escapeHTML(topImg)}" alt="${escapeHTML(
                    topName,
                  )}" loading="lazy" />`
                : `<div class="jtq-res__imgFallback">No image</div>`
            }
          </div>

          <div class="jtq-res__mainText">
            <div class="jtq-res__name">
              ${escapeHTML(topName)}
              ${
                topIconUrl
                  ? `<img class="jtq-res__iconImg" src="${escapeHTML(topIconUrl)}" alt="${escapeHTML(
                      topName,
                    )} icon" loading="lazy" />`
                  : ""
              }
            </div>

            ${topSubtitle ? `<div class="jtq-res__subtitle">${escapeHTML(topSubtitle)}</div>` : ""}
            ${topDesc ? `<div class="jtq-res__desc">${escapeHTML(topDesc)}</div>` : ""}
          </div>
        </div>

        <div class="jtq-res__sep"></div>

        <div class="jtq-res__secondary">
          <div class="jtq-res__secondaryLeft">
            <div class="jtq-res__secTitle">Your secondary character:</div>
            <div class="jtq-res__secName">
              ${escapeHTML(secondName)}
              ${
                secondIconUrl
                  ? `<img class="jtq-res__iconImg jtq-res__iconImg--sm" src="${escapeHTML(
                      secondIconUrl,
                    )}" alt="${escapeHTML(secondName)} icon" loading="lazy" />`
                  : ""
              }
            </div>
            ${secondSubtitle ? `<div class="jtq-res__secSub">${escapeHTML(secondSubtitle)}</div>` : ""}
          </div>

          <div class="jtq-res__secondaryRight">
            ${
              secondImgSmall
                ? `<img class="jtq-res__secImg" src="${escapeHTML(
                    secondImgSmall,
                  )}" alt="${escapeHTML(secondName)}" loading="lazy" />`
                : ""
            }
          </div>
        </div>

        <div class="jtq-res__sep jtq-res__sep--dashed"></div>

        <div class="jtq-res__grid">
          <section class="jtq-res__card">
            <h4 class="jtq-res__h4">Character Strength:</h4>
            <ul class="jtq-res__list">${listHTML(strengths)}</ul>
          </section>

          <section class="jtq-res__card">
            <h4 class="jtq-res__h4">Travel Style:</h4>
            <ul class="jtq-res__list">${listHTML(travelStyle)}</ul>
          </section>
        </div>

        <div class="jtq__nav jtq-res__nav">
          <button type="button" class="jtq__share" id="jtqShareBtn" style="background: #25D366; color: white; border: none;">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="vertical-align: middle; margin-right: 6px;">
              <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"></path>
              <polyline points="16 6 12 2 8 6"></polyline>
              <line x1="12" y1="2" x2="12" y2="15"></line>
            </svg>
            Share Hasil
          </button>
          <button type="button" class="jtq__restart">Ulangi</button>
        </div>
      </div>
    `;

    const shareBtn = screen.querySelector("#jtqShareBtn");

    if (shareBtn) {
      shareBtn.addEventListener("click", async () => {
        const originalText = shareBtn.innerHTML;
        shareBtn.innerHTML = "Memproses...";
        shareBtn.disabled = true;

        try {
          const pageStyle = window.getComputedStyle(
            document.querySelector(".jt-quiz-page") || document.body,
          );
          const bgImage = pageStyle.backgroundImage;

          const ghost = document.createElement("div");

          // Styling container gambar (Ghost Element)
          Object.assign(ghost.style, {
            width: "1080px",
            height: "1920px",
            position: "fixed",
            top: "-10000px",
            left: "-10000px",
            zIndex: "-9999",
            backgroundColor: "#FDF5F5",
            backgroundImage: `linear-gradient(rgba(253, 245, 245, 0.95), rgba(253, 245, 245, 0.95)), ${bgImage}`,
            backgroundSize: "300px",
            backgroundRepeat: "repeat",
            display: "flex",
            flexDirection: "column",
            padding: "80px",
            boxSizing: "border-box",
            textAlign: "center",
            fontFamily: "'Poppins', sans-serif",
            color: "#356289",
            justifyContent: "center",
            alignItems: "center",
          });

          // --- BAGIAN KONTEN GAMBAR DIMULAI DI SINI ---
          ghost.innerHTML = `
            <div style="font-size: 60px; font-weight: 800; margin-bottom: 60px; line-height: 1.3; color: #356289;">
              Kalau kamu karakter<br>
              <span style="font-style: italic;">iconic</span> Jepang, kamu adalah:
            </div>

            <div style="width: 800px; height: 800px; margin-bottom: 40px; display: flex; align-items: center; justify-content: center;">
              ${topImg ? `<img src="${topImg}" style="max-width: 100%; max-height: 100%; object-fit: contain; filter: drop-shadow(0 20px 40px rgba(53,98,137,0.3));" />` : ""}
            </div>

            <div style="display: flex; align-items: center; justify-content: center; margin-bottom: 20px;">
              <h1 style="font-size: 110px; font-weight: 900; margin: 0; text-transform: uppercase; letter-spacing: 2px; color: #356289; line-height: 1;">
                ${escapeHTML(topName)}
              </h1>
              ${topIconUrl ? `<img src="${topIconUrl}" style="width: 80px; height: 80px; margin-left: 30px; object-fit: contain;" />` : ""}
            </div>

            <div style="font-size: 42px; font-weight: 700; color: #356289; margin-bottom: 40px;">
              ${escapeHTML(topSubtitle)}
            </div>

            <div style="font-size: 32px; line-height: 1.5; font-weight: 500; color: #356289; max-width: 900px;">
              ${escapeHTML(topDesc)}
            </div>

            <div style="font-size: 24px; line-height: 1.5; font-weight: 400; color: #356289; margin-top: 50px; opacity: 0.9;">
              - Kamu ingin tau persona liburanmu? Check link in bio <strong>@japanlives</strong> -
            </div>
          `;
          // --- AKHIR BAGIAN KONTEN GAMBAR ---

          document.body.appendChild(ghost);

          await new Promise((r) => setTimeout(r, 500));
          const canvas = await html2canvas(ghost, {
            useCORS: true,
            scale: 1,
            width: 1080,
            height: 1920,
            logging: false,
            backgroundColor: null,
          });

          document.body.removeChild(ghost);

          canvas.toBlob(async (blob) => {
            const file = new File([blob], `Japantrips-Persona-${topName}.png`, {
              type: "image/png",
            });

            if (
              navigator.share &&
              navigator.canShare &&
              navigator.canShare({ files: [file] })
            ) {
              try {
                await navigator.share({
                  files: [file],
                  title: "My Japantrips Persona",
                  // Saya sesuaikan text share defaultnya juga agar konsisten
                  text: `Ternyata Persona Liburanku di Jepang adalah: ${topName}. Cek persona liburan Jepang kamu di sini: japantrips.id/pages/japantrips-quiz-persona`,
                });
              } catch (e) {
                console.log("Share batal");
              }
            } else {
              const link = document.createElement("a");
              link.download = `Japantrips-${topName}.png`;
              link.href = canvas.toDataURL();
              link.click();
              alert("Gambar tersimpan! Silakan cek galeri.");
            }

            shareBtn.innerHTML = originalText;
            shareBtn.disabled = false;
          }, "image/png");
        } catch (err) {
          console.error("Error:", err);
          alert("Gagal. Coba refresh.");
          shareBtn.innerHTML = originalText;
          shareBtn.disabled = false;
        }
      });
    }

    const restart = screen.querySelector(".jtq__restart");
    if (restart) {
      restart.addEventListener("click", () => {
        step = 0;
        leadDone = false;
        lead.name = "";
        lead.email = "";
        for (const k in answers) delete answers[k];
        render();
      });
    }
  }

  render();

  /* === Fungsi Add musik === */
  const musicBtn = document.getElementById("jtqMusicBtn");
  const bgm = document.getElementById("jtqBGM");

  if (musicBtn && bgm) {
    bgm.volume = 0.4;

    let isUserActive = false;

    const updateUI = (playing) => {
      const iconOn = musicBtn.querySelector(".music-icon-on");
      const iconOff = musicBtn.querySelector(".music-icon-off");
      const text = musicBtn.querySelector(".music-text");

      if (playing) {
        musicBtn.classList.add("is-playing");
        if (iconOn) iconOn.style.display = "inline";
        if (iconOff) iconOff.style.display = "none";
        if (text) text.textContent = "Music On";
      } else {
        musicBtn.classList.remove("is-playing");
        if (iconOn) iconOn.style.display = "none";
        if (iconOff) iconOff.style.display = "inline";
        if (text) text.textContent = "Music Off";
      }
    };

    const playAudio = () => {
      return bgm
        .play()
        .then(() => {
          isUserActive = true;
          updateUI(true);
          return true;
        })
        .catch((e) => {
          console.log("Audio play tertahan browser (menunggu interaksi user)");
          return false;
        });
    };

    const pauseAudio = () => {
      bgm.pause();
      isUserActive = false;
      updateUI(false);
    };

    musicBtn.addEventListener("click", (e) => {
      e.stopPropagation();
      if (bgm.paused) playAudio();
      else pauseAudio();
    });

    const startOnInteraction = async (e) => {
      if (bgm.paused && !isUserActive) {
        // Coba play
        const success = await playAudio();

        if (success) {
          document.removeEventListener("pointerdown", startOnInteraction);
          document.removeEventListener("keydown", startOnInteraction);
        }
      }
    };

    document.addEventListener("pointerdown", startOnInteraction);
    document.addEventListener("keydown", startOnInteraction);
    document.addEventListener("visibilitychange", () => {
      if (document.hidden) {
        bgm.pause();
      } else {
        if (isUserActive && bgm.paused) {
          bgm.play().catch((e) => {});
        }
      }
    });
  }
})();
